import { useEffect } from 'react';
import { LastWebsocketJsonMessageType } from '@interfaces/webSocketConnectionInfo';
import { useMytaStreams } from './MytaStreamsProvider';

// The one websocket handler that reads a message whose session key is NOT the current one — on purpose, and for
// one message class only (seatMove.ts `moveEntryProof`). During a packing move the second UE logs in under its
// own key; its TELEPORT_FINISHED is the proof the switch waits for, and every other handler rightly skips it.
// Nothing else about that session reaches the hub until the switch adopts the key.
export const useHandleSeatMoveSessionMsg = (
  lastJsonMessage: LastWebsocketJsonMessageType,
) => {
  const { noteSessionEvent } = useMytaStreams();

  useEffect(() => {
    if (!lastJsonMessage?.action) {
      return;
    }
    noteSessionEvent(lastJsonMessage.action, lastJsonMessage.sessionKey);
  }, [lastJsonMessage, noteSessionEvent]);
};
